import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';

export default class Cobro extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'prop/user', saveUrl: 'prop/user', backUrl: '/Catalogo/User' },
      new Form([
        Form.Field('text', 'cobro_iva', '% de I.V.A aplicado', '', [], 12),
        Form.Field('text', 'cobro_retencion', '% de Retencion', '', [], 12),
        Form.Field('text', 'cobro_seguro', '% de Seguro', '', [], 12),
        Form.Field('text', 'cobro_factor_carga', 'Factor para calcular maniobras de carga', '', [], 12),
        Form.Field('text', 'cobro_factor_descarga', 'Factor para calcuar maniobras de descarga', '', [], 12),
      ], ['Guardar'], 'Configurar Cobro'), this.formData
    )
    this.LoadPreds();
  }

  LoadPreds = async () => {
    let Res = await Http.get(`prop/user`);
    if (!Res.error)
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
  }

  onSubmit = async (i, vals) => {
    try {
      let Res = await Http.post('prop/user/save', { ...vals });
      if(!Res.error) {
        
      }
    } catch (error) {

    }
  }

  render() {
    return (
      <div style={{ minWidth: '100%', padding: '5px' }} >
        <this.FormRender {...this.props} />
      </div>
    )
  }
}
